export const INVOICE_STATUS = {
  OPEN: 'Open',
  PAIDINFULL: 'PaidInFull',
  OTHER: 'Other',
  DEPOSITED: 'Deposited',
};

export const INVOICE_STATUS_MAPPER = {
  OPEN: INVOICE_STATUS.OPEN,
  PAIDINFULL: INVOICE_STATUS.PAIDINFULL,
  DEPOSITED: INVOICE_STATUS.DEPOSITED,
};
